import disclaimerModalWarning from "../../resources/js/module/disclaimer-modal";
import mapController from "../../resources/js/module/mapController";
import MapFilter from "../../resources/js/module/mapFilter";

document.addEventListener('DOMContentLoaded', () => {
    const disclaimerModal = document.querySelector('.tr-disclaimer-modal');
    const map = document.querySelector('#interactive-map > svg');

    if (disclaimerModal) {
        disclaimerModalWarning(disclaimerModal, disclaimerModal.dataset.modalShow);
    }

    if (map) {
        const mapFilter = new MapFilter();
        mapFilter.init();
        mapController(map, {
            disableInteractions: true,
        });
    }
});
